import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import BusinessPage from "../pages/business/page";
import OpportunityDetailPage from "../pages/business/OpportunityDetailPage";
import TendersPage from "../pages/tenders/page";
import EventsPage from "../pages/events/page";
import EventDetailPage from "../pages/events/EventDetailPage";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/business/opportunity/:id",
    element: <OpportunityDetailPage />,
  },
  {
    path: "/tenders",
    element: <TendersPage />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/events/:id",
    element: <EventDetailPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
